export const getPagesData = graphqlModel => graphqlModel.allFile.nodes[0].childMarkdownRemark.frontmatter; 